import script from "./GlobalOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalOverlay.vue?vue&type=script&setup=true&lang=js"

import "./GlobalOverlay.vue?vue&type=style&index=0&id=5df09f46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5df09f46"]])

export default __exports__